import { resolveVatRate } from './vat.util';

/** Methods where money changed hands. Only these can be swapped for one another on a captured receipt. */
export const MONEY_PAYMENT_METHODS = ['Cash', 'Card', 'Yoco: Card Machine', 'Yoco: Online', 'EFT: Patient', 'EFT: Medical Scheme'];

/** A live receipt paid in money, not through the Yoco integration, can have its method corrected. */
export function canChangePaymentMethod(receipt: any): boolean {
  const payment = receipt?.PatientPayment;
  return !!payment && !receipt.removedAt && !payment.yocoPaymentId && MONEY_PAYMENT_METHODS.includes(payment.paymentMethod);
}

const coreNumber = (billingNumber: string) => (billingNumber || '').replace(/^(INV-|RCPT-|EST-)/, '');

/**
 * The data generateReceiptPDF needs to redraw a receipt, built from the payment as the method-change
 * endpoint returns it. A receipt carries its invoice's number, which picks the allocation; a payment
 * on a single invoice uses that one. Returns null when the invoice cannot be found.
 */
export function receiptPdfData(receipt: any, payment: any, group: any): any {
  const allocations = payment.PatientPaymentAllocations || [];
  const receiptCore = coreNumber(receipt.billingNumber);
  const allocation = allocations.find((a: any) => receiptCore.startsWith(coreNumber(a.PatientBillingDocument?.billingNumber)))
    || (allocations.length === 1 ? allocations[0] : null);
  const invoice = allocation?.PatientBillingDocument;
  if (!invoice) return null;

  const patient = payment.Patient;
  const outstandingBalance = parseFloat(invoice.outstandingBalance || 0);
  return {
    billingNumber: receipt.billingNumber,
    patientName: `${patient.name} ${patient.surname}`,
    patient,
    paymentDate: payment.paymentDate,
    paymentMethod: payment.paymentMethod,
    amountRecieved: parseFloat(allocation.allocatedAmount),
    lineItems: (invoice.PatientBillingLineItems || []).map((item: any) => ({
      ...item,
      balance: item.totalAmount,
      tariffCode: item.code,
      tariffDescription: item.description,
    })),
    payments: [{ linkedInvoice: invoice.billingNumber, allocatedAmount: parseFloat(allocation.allocatedAmount), balance: outstandingBalance }],
    outstandingBalance,
    notes: receipt.notes,
    practiceInfo: {
      practiceName: group.companyName || group.name,
      practiceNumber: group.practiceNumber,
      email: group.practiceEmail,
      tel: group.practicePhone,
    },
    user: payment.User,
    group,
    provider: receipt.Provider,
    hospital: invoice.priceGroupId,
    vatExclusive: invoice.vatExclusive === true,
    vatRate: resolveVatRate(invoice.vatRate, group),
  };
}
